import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";

function JdForm() {
  const navigate = useNavigate();
  const [Role, setRole] = useState("");
  const [Description, setDescription] = useState("");
  const [MandatorySkills, setMandatorySkills] = useState("");
  const [OptionalSkills, setOptionalSkills] = useState("");
  const [TotalExperience, setTotalExperience] = useState("");
  const [RelevantExperience, setRelevantExperience] = useState("");
  const [Education, setEducation] = useState("");
  const [Location, setLocation] = useState("");
  const [offered_CTC, setOffered_CTC] = useState("");

  // State for weightage percentages
  const [mandatorySkillsWeight, setMandatorySkillsWeight] = useState("");
  const [relevantExperienceWeight, setRelevantExperienceWeight] = useState("");
  const [educationWeight, setEducationWeight] = useState("");
  const [locationWeight, setLocationWeight] = useState("");
  const [optionalSkillsWeight, setOptionalSkillsWeight] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    const totalWeightage =
      Number(mandatorySkillsWeight) +
      Number(relevantExperienceWeight) +
      Number(educationWeight) +
      Number(locationWeight) +
      Number(optionalSkillsWeight);

    if (totalWeightage !== 100) {
      alert("Total weightage must be 100%");
      return;
    }

    const storedClient = localStorage.getItem("client");
    const createdBy = localStorage.getItem("user_id");

    const clientId =
      storedClient && !isNaN(storedClient) ? Number(storedClient) : null;
    const userId = createdBy && !isNaN(createdBy) ? Number(createdBy) : null;

    if (!clientId || !userId) {
      alert("Client ID or User ID is missing. Please log in again.");
      return;
    }

    const formData = {
      role: Role,
      description: Description,
      mandatory_skills: MandatorySkills,
      optional_skills: OptionalSkills,
      total_experience: TotalExperience,
      relevant_experience: RelevantExperience,
      education: Education,
      location: Location,
      offered_CTC: offered_CTC,
      client: clientId,
      created_by: userId,

      // ✅ Fix: Flattened weightage fields
      mandatory_skills_weight: Number(mandatorySkillsWeight),
      relevant_experience_weight: Number(relevantExperienceWeight),
      education_weight: Number(educationWeight),
      location_weight: Number(locationWeight),
      optional_skills_weight: Number(optionalSkillsWeight),
    };

    console.log("Submitting Form Data:", formData);

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/`,
        formData
      )
      .then((response) => {
        console.log("Success:", response.data);
        navigate("/jd_dashboard");
      })
      .catch((error) => {
        console.error(error);
        alert("Error submitting the form.");
      });
  };

  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container py-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-7 col-xl-5 log">
            <div className="card border border-dark bg-transparent text-white">
              <div
                className="card-header border-dark"
                style={{ background: "#008cba" }}
              >
                <h4 className="text-center font_header">
                  JD Configurator Form
                </h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit} className="text-dark">
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Role</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        value={Role}
                        onChange={(e) => setRole(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        value={Description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label htmlFor="TotalExperience" className="form-label">
                        Total Experience
                      </label>
                      <input
                        type="text"
                        className="form-control border-dark text-dark"
                        id="TotalExperience"
                        value={TotalExperience}
                        onChange={(e) => setTotalExperience(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label" htmlFor="ectc">
                        Offered CTC
                      </label>
                      <input
                        type="text"
                        id="ectc"
                        className="form-control border-dark text-dark"
                        value={offered_CTC}
                        onChange={(e) => setOffered_CTC(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Mandatory Skills + Weightage */}
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Mandatory Skills</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        value={MandatorySkills}
                        onChange={(e) => setMandatorySkills(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Weightage (%)</label>
                      <input
                        type="number"
                        className="form-control border-dark"
                        value={mandatorySkillsWeight}
                        onChange={(e) =>
                          setMandatorySkillsWeight(e.target.value)
                        }
                      />
                    </div>
                  </div>

                  {/* Optional Skills + Weightage */}
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Optional Skills</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        value={OptionalSkills}
                        onChange={(e) => setOptionalSkills(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Weightage (%)</label>
                      <input
                        type="number"
                        className="form-control border-dark"
                        value={optionalSkillsWeight}
                        onChange={(e) =>
                          setOptionalSkillsWeight(e.target.value)
                        }
                      />
                    </div>
                  </div>

                  {/* Relevant Experience + Weightage */}
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label border-dark">
                        Relevant Experience
                      </label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        value={RelevantExperience}
                        onChange={(e) => setRelevantExperience(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Weightage (%)</label>
                      <input
                        type="number"
                        className="form-control border-dark"
                        value={relevantExperienceWeight}
                        onChange={(e) =>
                          setRelevantExperienceWeight(e.target.value)
                        }
                      />
                    </div>
                  </div>

                  {/* Education + Weightage */}
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Education</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        value={Education}
                        onChange={(e) => setEducation(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Weightage (%)</label>
                      <input
                        type="number"
                        className="form-control border-dark"
                        value={educationWeight}
                        onChange={(e) => setEducationWeight(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Location + Weightage */}
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Location</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        value={Location}
                        onChange={(e) => setLocation(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Weightage (%)</label>
                      <input
                        type="number"
                        className="form-control border-dark"
                        value={locationWeight}
                        onChange={(e) => setLocationWeight(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="text-center py-2">
                    <button type="submit" className="btn btn-outline-info me-2">
                      Submit
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => navigate("/jd_dashboard")}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default JdForm;
